// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"5fe29fba","453":"6db2394c","506":"727ad5ae"}[chunkId] + ".chunk.js";
};